import { createSelector } from 'reselect';
const getDepartments = (state) => state.departments || {};
export const selectFetching = createSelector(getDepartments, ({ fetching }) => fetching);
export const selectDepartmentsOptions = createSelector(getDepartments, ({ options }) => options);
export const selectDepartmentsList = createSelector(getDepartments, ({ list }) => list);
export const selectDepartmentById = createSelector(getDepartments, ({ list }) => (id) => list.find((department) => department.DepartmentId === id));
